﻿import { useContext } from "react";

import { ITranslationsContext, TranslationsContext } from "./TranslationsContext";

export function useTranslations(): ITranslationsContext {
  const context = useContext(TranslationsContext);
  if (!context) {
    throw new Error("useTranslations must be used within a TranslationsProvider");
  }

  return context;
}
